import { isRecaptchaClientSetupErrorMessage } from "@/utils/recaptcha";

export default function SearchVinForm({
  t,
  value,
  onChange,
  onSubmit,
  disabled,
  error,
  recaptchaSetupHint = "",
}) {
  const errStr = typeof error === "string" ? error : "";
  const setupLike = isRecaptchaClientSetupErrorMessage(errStr);
  const showDevDomainsHint =
    setupLike &&
    recaptchaSetupHint &&
    (/localhost/i.test(errStr) ||
      /127\.0\.0\.1/i.test(errStr) ||
      /supported domains/i.test(errStr));

  return (
    <form
      className="max-w-xl mx-auto rounded-xl border border-[#e2e6ec] bg-white p-6 shadow-sm"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <label className="block text-xs font-mono uppercase tracking-[0.18em] text-slate-600 mb-2">
        {t.vinLabel}
      </label>
      <input
        data-testid="vin-parts-input"
        className="w-full border border-[#d7deea] px-4 py-3 font-mono text-sm uppercase tracking-wide outline-none focus:border-[#0b378c]"
        placeholder={t.vinPlaceholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoCapitalize="characters"
        spellCheck={false}
        disabled={disabled}
      />
      {error ? (
        setupLike ? (
          <div
            className="mt-4 rounded-xl border-2 border-red-600 bg-red-50 px-4 py-5 sm:px-6 sm:py-6 shadow-sm"
            role="alert"
          >
            {showDevDomainsHint ? (
              <p className="text-sm sm:text-base font-semibold text-red-950 leading-snug">{recaptchaSetupHint}</p>
            ) : null}
            <p
              className={`font-medium text-red-900 leading-snug break-words ${showDevDomainsHint ? "mt-3" : ""} text-base sm:text-lg md:text-xl`}
            >
              {error}
            </p>
          </div>
        ) : (
          <p className="mt-3 text-sm sm:text-base text-red-800 leading-snug break-words" role="alert">
            {error}
          </p>
        )
      ) : null}
      <button
        type="submit"
        data-testid="vin-parts-submit"
        disabled={disabled}
        className="mt-5 w-full sm:w-auto bg-[#0b378c] hover:bg-[#082a6d] disabled:opacity-60 text-white font-bold uppercase tracking-wider text-xs px-8 py-3 transition-colors"
      >
        {disabled ? t.loading : t.searchBtn}
      </button>
    </form>
  );
}
